export const getExceptionToAcceptanceApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/exception-to-acceptance/${queryString ? `?${queryString}` : ""}`;
};

export const addExceptionToAcceptanceApi = (params) => {
    return `lease/${params?.leaseSlug}/exception-to-acceptance/`;
}

export const updateExceptionToAcceptanceApi = (params) => {
    return `lease/${params?.leaseSlug}/exception-to-acceptance/${params?.slug}/`;
};

export const deleteExceptionToAcceptanceApi = (params) => {
    return `lease/${params?.leaseSlug}/exception-to-acceptance/`;
};

export const exportExceptionToAcceptanceApi = (leaseId) => {
    return `lease/${leaseId}/export/exception-to-acceptance/`;
};

export const exceptionsToAcceptancefileUploadPostApi = (exceptions_to_acceptance_slug) => {
    return `/get-pre-signed-url/exceptions_to_acceptance/${exceptions_to_acceptance_slug}`;
};

export const exceptionsToAcceptanceAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/exceptions_to_acceptance/${attachments_slug}`
}
